<template>
  <div>





<h2 class="goth">Relativa pronomen</h2>
<div class="grammatikparagrafbredd leftorient">




<p><i>Relativa pronomen</i> kallas sådana pronomen som återsyftar på något, ett <i>korrelat</i>, som precis
    tidigare nämnts i samma mening. Det vanligaste relativa pronomenet på
    svenska är ordet <i>som</i>. </p>

<div class="ruta">

<div class="quasi-p">
<div class="upp"><i>Där står </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>mannen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>har en katt.</i></div>
</div>



<div class="quasi-p">
<div class="upp"><i>Där står </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>bilen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<BakatpilLiten/></div></div></div>
<div class="upp"><i>är blå.</i></div>
</div>



<div class="quasi-p">
<div class="upp"><i>Där står </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>kvinnan</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>sjunger så bra.</i></div>
</div>


<div class="quasi-p">
<div class="upp"><i>Där leker </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>barnen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>bor här.</i></div>
</div>

</div>
<p class="minitext"> I ovanstående exempel står <u>korrelatet</u> understruket och det <b>relativa pronomenet</b> fetstilt.


<p>Svenskan är enkel i detta fall. Oavsett genus, och numerus
    (singular eller plural) som ordet <i>som</i> återsyftar på, och oavsett
    vilken funktion <i>som</i> har i bisatsen (subjekt, ackusativobjekt o.s.v.)
    förblir det oböjt (undantag genitiv då man säger <i>vars</i>).</p>

<br>


<p>Tyskan är mer komplicerad. Man måste tänka på:</p>
<ul>
<li>Genus och numerus på korrelatet i huvudsatsen</li><br>
<li>Relativa pronominets satsfunktion och motsvarande kasus i bisatsen</li>
</ul>
<br><br>

<h4>Relativa prononmen i nominativ</h4>

<div class="quasi-p">Till att börja med nöjer vi oss till med att titta på exempel där
    det relativa pronomenet står som subjekt i bisatsen, alltså i <b>nominativ</b>. I dessa fall (och de flesta andra) är
de relativa pronomina <b>likadana</b> som korrelatets <b>bestämda artikel</b>.
</div>
<br>




<div class="ruta">

<div class="quasi-p">
<div class="upp"><i>Där står </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>mannen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>har en katt.</i></div>
</div>
<div class="quasi-p">
<div class="upp"><i>Da steht </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>der Mann</u>,&nbsp; <b>der</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>eine Katze hat.</i></div>
</div>

<br>

<div class="quasi-p">
<div class="upp"><i>Där står </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>bilen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<BakatpilLiten/></div></div></div>
<div class="upp"><i>är blå.</i></div>
</div>


<div class="quasi-p">
<div class="upp"><i>Da steht </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>das Auto</u>,&nbsp; <b>das</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>blau ist.</i></div>
</div>

<br>

<div class="quasi-p">
<div class="upp"><i>Där står </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>kvinnan</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>sjunger så bra.</i></div>
</div>
<div class="quasi-p">
<div class="upp"><i>Da steht </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>die Frau</u>,&nbsp; <b>die</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>so gut singt.</i></div>
</div>

<br>

<div class="quasi-p">
<div class="upp"><i>Där leker </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>barnen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>bor på här.</i></div>
</div>

<div class="quasi-p">
<div class="upp"><i>Da spielen </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>die Kinder</u>,&nbsp; <b>die</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>hier wohnen.</i></div>
</div>

</div>
<br>


<div class="quasi-p"><b>Relativa pronomen inleder</b> relativ <b>bisats</b>.
    Tänk på att i alla bisatser
    hamnar det <b>finita</b> (personböjda) <b>verbet sist</b>.</div>

<p>
    Ibland kan den relativa bisatsen så inskjuten i en huvudsats. På tyskan används ALLTID kommatecken mellan huvudsats och bisats.
</p>

<br>
<div class="ruta">

<div class="quasi-p">
<div class="upp"><i> </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>Mannen</u>&nbsp; <b>som</b></i> &nbsp; <br><div>&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>är gammal, har två barn.</i></div>
</div>
<div class="quasi-p">
<div class="upp"><i> </i> </div>
<div class="p-stil"><div class="dubbelrad"><i><u>Der Mann</u>,&nbsp; <b>der</b></i> &nbsp; <br><div>&nbsp;&nbsp;&nbsp;&nbsp;<Bakatpil/></div></div></div>
<div class="upp"><i>alt ist, hat zwei Kinder.</i></div>
</div>

</div>
<br>





</div>
</div>


</template>

<script>
import Bakatpil from '../grafik/bakatpil.vue'
import BakatpilLiten from '../grafik/bakatpilLiten.vue'
//import BakatpilStor from '../grafik/bakatpilStor.vue'

export default {
  name: 'Grammatik',

  components: {
    Bakatpil,
    BakatpilLiten

},



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
